module.exports = __webpack_public_path__ + "img/14.430d09b0.png";